/* eslint-disable no-unused-vars */
/**
 * Imports necessary dependencies from React and other modules.
 * @import React - the main React library
 * @import useEffect - a React hook for handling side effects
 * @import useRef - a React hook for creating mutable variables
 * @import useState - a React hook for managing state
 * @import useTranslation - a hook for internationalization
 * @import useDispatch - a hook for accessing the Redux dispatch function
 * @import CustomToggleButton - a custom toggle button component
 * @import CustomButton - a custom button component
 * @import TextField - a text field component
 * @import HookForm - a form component
 * @import NoticeTypeComponent - a component for displaying notice types
 * @import showToast - a function for
 */
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import CustomToggleButton from "../../components/customToggleButton/customToggleButton";
import CustomButton from "../../components/customButton/customButton";
import TextField from "../../components/textField/textField";
import HookForm from "../../components/hookForm/hookForm";
import NoticeTypeComponent from "./noticeTypeComponent";
import { getNoticeTypeList, addNoticeType, editNoticeType, noticeTypeDelete, noticeEditTypeStatus, editReduxState, deleteReduxState, editStatusReduxState, editSignStatusReduxState } from "../../store/noticeType/actions";

// import "./noticeType.scss";
import { debounce } from "lodash";
import useWindowDimension from "../../components/hooks/useWindowDimension";
import _ from "lodash";
import CustomeShimer from "../../components/customeShimer/customeShimer";
import Constant from "../../util/constant";
import { Helmet } from 'react-helmet';

/**
 * A functional component that renders a notice type component.
 * @param {{object}} props - The component props.
 * @param {{boolean}} props.showDeleteUserModal - A boolean indicating whether the delete user modal is shown or not.
 * @param {{function}} props.openDeleteUserModal - A function to open the delete user modal.
 * @param {{function}} props.closeDeleteUserModal - A function to close the delete user modal.
 * @param {{function}} props.onDeleteUser - A function to handle the delete user action.
 * @param {{function}} props.onProcced - A function to handle the proceed action.
 * @param {{array}} props.columns - An array of column objects for the table.
 *
 */
const NoticeType = (props) => {
  const dimensions = useWindowDimension();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const smarttableref = useRef();
  const tableContainerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const pageSizeRef = useRef(dimensions.width > 1920 ? 25 : 10);
  const toggleDisable = useRef(false);
  const noticeTypeData = useSelector((state) => state?.NoticeType?.noticeList?.data)
  const [searchValue, setSearchValue] = useState(null);
  const [showDeleteUserModal, setshowDeleteUserModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [editButtonstate, setEditButtonstate] = useState(false);
  const [signInRequired, setSignInRequired] = useState(!true);
  const [isaddButtonLoader, setIsaddButtonLoader] = useState(false);
  const [isupdateButtonLoader, setIsupdateButtonLoader] = useState(false);
  const [disableModelLoaderBotton, setDisableModelLoaderBotton] = useState(false);
  const [noticeTypeForm, setNoticeTypeForm] = useState("");
  const [editID, setEditID] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [enableDisableID, setEnableDisableID] = useState("");
  const [updateNotice, setUpdateNotice] = useState("");
  const [issetupdateNotice, setIssetupdateNotice] = useState("");
  const [noticeTypetextcount, setNoticeTypeTextCount] = useState(0);
  const [tableFilterHeight, setTableFilterHeight] = useState("");
  const [breadcrumbHeight, setBreadcrumbHeight] = useState("");
  const [tabHeaderHeight, setTabHeaderHeight] = useState("");
  const [headerHeight, setHeaderHeight] = useState("");
  const [loaderHtml, setLoaderHtmlHeight] = useState("");
  const [placeHolder, setPlaceHolder] = useState(true);
  const [searchedData, setSearchedData] = useState(noticeTypeData);
  console.log('bbb', noticeTypeData)
  useEffect(() => {
    setSearchedData(noticeTypeData)
  }, [ noticeTypeData]);
  useEffect(() => {
    loading &&
      setLoaderHtmlHeight(
        document.getElementsByClassName("infinate-load")[0].offsetHeight
      );
    setHeaderHeight(
      document.getElementsByClassName("navbar-header")[0].offsetHeight
    );
    setBreadcrumbHeight(
      document.getElementsByClassName("page-title-box")[0].offsetHeight
    );
    setTableFilterHeight(
      document.getElementsByClassName("col-form-label")[0].offsetHeight
    );
    setTabHeaderHeight(document.getElementsByTagName("thead")[0].offsetHeight);
  }, [loading]);


  const closeDeleteUserModal = () => setshowDeleteUserModal(false);
  const openDeleteUserModal = (e, item) => {
    setDeleteId(item?.noticetypeid);
    if (item?.noofnotice > 0) {
      dispatch(noticeTypeDelete(item?.noticetypeid, (res) => {

      }, (err) => { console.log(err); }))
    } else {
      setshowDeleteUserModal(true);
    }
  }
  const closeDeactivateModal = () => setShowStatusModal(false);
  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);




  /**
   * Retrieves a list of notices using an access token from local storage.
   * @returns None
   */
  const getList = () => {
    dispatch(getNoticeTypeList({}, (res) => {
      if (res) {
        setPlaceHolder(false);
      }
    }, (err) => { console.log(err); }))
  }

  /**
  * Handles the submission of a form by sending a request to add a notice.
  * @param {{object}} data - The form data to be submitted.
  * @returns None
  */
  const handleFormSubmit = (data) => {
    
    setNoticeTypeTextCount(0);
    if (editButtonstate) {
      const params = {
        name: data?.Notice,
        signrequired: signInRequired
      }
      dispatch(editNoticeType(editID, params, (res) => {
        if (res) {
          const _upatedList = noticeTypeData?.map((item) => {
            if (item?.noticetypeid === editID) {
              return { ...item, name: data?.Notice, signrequired: signInRequired }
            }
            return item;
          })
          dispatch(editReduxState(_upatedList))
          setEditButtonstate(false)
          
        }
      }, (err) => { console.log(err); }))
    } else {
      const params = {
        name: data?.Notice,
        signrequired: signInRequired
      }
      dispatch(addNoticeType(params, (res) => {
        getList();
      }, (err) => { console.log(err); }))
    }
    setSignInRequired(false);
    noticeTypeForm?.reset(
      {
        Notice: "",
      });
  }
  /**
   * Initializes the noticeTypeData state variable with the data from the noticeTypeData object.
   * @param {{object}} noticeTypeData - The noticeTypeData object containing the data.
   * @returns None
   */
  const checkNoOfTypelength = noticeTypeData?.map((item) => item?.noofnotice);

  /**
   * Creates a form object for a notice type.
   * @returns {{Object}} - The form object with the notice type configuration.
   */
  const CreateNoticeTypeForm = {
    NoticeType: {
      name: "Notice",
      validate: {
        required: {
          value: true,
        },
        pattern: {
          value: false,
        },
        maxLength: {
          value: 150,
        },
      },
    },
  };

  /**
   * An array of column objects used for rendering a table.
   * @type {Array}
   * @property {string | JSX.Element} label - The label or JSX element to display in the column header.
   * @property {string} key - The key used to access the data for this column in each row.
   * @property {boolean} filter - Indicates whether filtering is enabled for this column.
   * @property {boolean} sorting - Indicates whether sorting is enabled for this column.
   * @property {string | JSX.Element} group - The label or JSX element to display in the group header.
   * @property {Array} children - An array of child column objects.
   * @property {string} _style - Additional CSS styles to apply
   */
  const columns = [
    {
      label: <>{t("NOTICE_TYPE")}</>,
      key: "name",
      filter: false,
      sorting: false,
      group: <>{t("NOTICE_TYPE")}</>,
      children: [
        {
          group: (
            <>
              <div className="AddNotice">
                <HookForm
                  defaultForm={{
                    Notice: "",
                  }}
                  init={(form) => {
                    setNoticeTypeForm(form);
                  }}
                  onSubmit={(e) => {
                    handleFormSubmit(e)
                  }}
                  className="form-horizontal"
                >
                  {(formMethod) => {
                    return (
                      <>
                        <div className="AddNoticeForm">
                          {placeHolder && <CustomeShimer />}

                          <div className="AddNoticeTextField">
                            <TextField
                              formMethod={formMethod}
                              rules={CreateNoticeTypeForm.NoticeType.validate}
                              name={CreateNoticeTypeForm.NoticeType.name}
                              errors={formMethod?.formState.errors}
                              autoFocus={true}
                              type="text"
                              placeholder="Enter name of notice type"
                              textCountVisible={true}
                              textcount={noticeTypetextcount}
                              textCountTotal={150}
                              onChange={(e) => {
                                setUpdateNotice(e.target.value);
                                handlefullnametextcount(e);
                              }}
                            />
                          </div>
                          <div className="SignRequired">
                            <p>{t("SIGN_REQUIRED")}</p>
                            <CustomToggleButton
                              id=""
                              checked={signInRequired}
                              onCheckChange={(e) => {
                                setSignInRequired(!signInRequired);
                              }}
                            />
                            <p>
                              {signInRequired ? (
                                <span>Yes</span>
                              ) : (
                                <span>No</span>
                              )}
                            </p>
                          </div>
                         { console.log('editButtonstate', editButtonstate)}
                          {editButtonstate ? (
                            <CustomButton
                              className="black-btn Fill_Button"
                              type="submit"

                              disabled={
                                (updateNotice === issetupdateNotice && true) ||
                                !formMethod?.formState?.isValid
                              }
                              loading={isupdateButtonLoader}
                            >
                              {t("Update")}
                            </CustomButton>
                          ) : (
                            <CustomButton
                              className="black-btn Fill_Button"
                              type="submit"
                              disabled={!formMethod?.formState?.isValid}

                              loading={isaddButtonLoader}
                            >
                              {t("Add")}
                            </CustomButton>
                          )}
                        </div>
                      </>
                    );
                  }}
                </HookForm>
              </div>
            </>
          ),
          children: [
            {
              label: " ",
              key: "name",
              _style: { display: "none" },
              sorting: false,
            },
          ],
        },
      ],
    },
    {
      label: <>{t("SIGN_REQUIRED")}</>,
      key: "signrequired",
      filter: false,
      group: <>{t("SIGN_REQUIRED")}</>,
      sorting: false,

      children: [
        {
          group: <></>,
          children: [
            {
              label: " ",
              key: "signrequired",
              _style: { display: "none" },
              sorting: false,
            },
          ],
        },
      ],
    },
    {
      label: (
        <>
          {t("NO_OF_NOTICE")}{" "}
          <span className="thCount">{_.sum(checkNoOfTypelength)}</span>
        </>
      ),
      key: "noofnotice",
      filter: false,
      group: (
        <>
          {t("NO_OF_NOTICE")}
          <span className="thCount">{_.sum(checkNoOfTypelength)}</span>

        </>
      ),
      sorting: false,

      children: [
        {
          group: <></>,
          children: [
            {
              label: " ",
              key: "noofnotice",
              _style: { display: "none" },
              sorting: false,
            },
          ],
        },
      ],
    },
    {
      label: "Actions",
      key: "noticetypestatus",
      filter: false,
      group: "Actions",
      sorting: false,
      children: [
        {
          group: <></>,
          children: [
            {
              label: " ",
              key: "noticetypestatus",
              filter: false,
              sorting: false,
              _style: { display: "none" },
            },
          ],
        },
      ],
    },
  ];

  const handlefullnametextcount = (e) => {
    const value = e.target.value;
    setNoticeTypeTextCount(value?.length);
  };

  /**
   * Handles the deletion of a user.
   * @param {Event} e - The event object.
   * @param {Object} item - The user object to be deleted.
   * @returns None
   */
  const onDeleteUser = (e, item) => {
    dispatch(noticeTypeDelete(deleteId, (res) => {
      if (res) {
        dispatch(deleteReduxState(noticeTypeData?.filter((item) => item?.noticetypeid !== deleteId)))
      }
    }, (err) => { console.log(err); }))
    closeDeleteUserModal();
  };


  /**
   * Handles the action when the user proceeds with disabling a notice type.
   * Updates the status of the notice type to Constant.GENERALKEYS.INACTIVE in the notice type array.
   * Closes the status modal.
   * Displays a success toast message.
   * @returns None
   */
  const onDeactivate = () => {
    const params = {
      noticetypestatus: Constant.GENERALKEYS.INACTIVE
    }
    setDisableModelLoaderBotton(true);
    dispatch(noticeEditTypeStatus(enableDisableID?.noticetypeid, params, (res) => {
      if (res) {
        const _upatedList = noticeTypeData?.map((item) => {
          if (item?.noticetypeid === enableDisableID?.noticetypeid) {
            return { ...item, noticetypestatus: Constant.GENERALKEYS.INACTIVE }
          }
          return item;
        })
        dispatch(editStatusReduxState(_upatedList))
      }
      setShowStatusModal(false);
      setDisableModelLoaderBotton(false);
    }, (err) => { setDisableModelLoaderBotton(false); setShowStatusModal(false); console.log(err); }));
  };
  /**
   * Handles the action when unable to perform a certain action.
   * @param {Error} e - The error object that occurred.
   * @param {string} id - The ID of the item that the action was performed on.
   * @returns None
   */
  const onActive = (e, id) => {
    const params = {
      noticetypestatus: Constant.GENERALKEYS.ACTIVE
    }
    if (!toggleDisable.current) {
      toggleDisable.current = true
      dispatch(noticeEditTypeStatus(id, params, (res) => {
        if (res) {
          const _upatedList = noticeTypeData?.map((item) => {
            if (item?.noticetypeid === id) {
              return { ...item, noticetypestatus: Constant.GENERALKEYS.ACTIVE }
            }
            return item;
          })
          dispatch(editStatusReduxState(_upatedList))
          toggleDisable.current = false
        }
      }, (err) => {
        toggleDisable.current = false
      }))
    }
  };

  /**
   * Updates the notice type form and sets the state for the update notice.
   * @param {{Event}} e - The event object.
   * @param {{any}} item - The item to update.
   * @returns None
   */
  const onUpdateNoticeTypeFun = (e, item) => {
    noticeTypeForm?.setValue("Notice", item?.name, {
      shouldValidate: true,
    });
    setIssetupdateNotice(item?.name);
    setNoticeTypeTextCount(item?.name?.length);
    setUpdateNotice(noticeTypeForm.getValues("Notice"));
    setEditButtonstate(true);
    setEditID(item?.noticetypeid);
    noticeTypeForm.setValue("Notice", item?.name, {
      shouldValidate: false,
    });
    setSignInRequired(item?.signrequired);
    setUpdateNotice(noticeTypeForm.getValues("Notice"));
  };


  /**
   * Handles the action when a checkbox is checked or unchecked.
   * @param {{Event}} e - The event object.
   * @param {{object}} item - The item associated with the checkbox.
   * @returns None
   */
  const onCheckAction = (e, item) => {
    setEnableDisableID(item)
    const status = item?.noticetypestatus;
    if (status === Constant.GENERALKEYS.ACTIVE) {
      if (item?.noofnotice > 0) {
        const params = {
          noticetypestatus: Constant.GENERALKEYS.INACTIVE
        }
        dispatch(noticeEditTypeStatus(item?.noticetypeid, params, (res) => {
        }, (err) => { console.log(err); }))
      } else {
        setShowStatusModal(true);
      }
    } else {
      onActive(e, item?.noticetypeid);
    }
  };
  /**
   * Handles the event when a sign checkbox is checked or unchecked.
   * @param {{Event}} e - The event object.
   * @param {{object}} item - The item object representing the notice type.
   * @returns None
   */
  const onCheckSign = (e, item) => {
    if (item?.signrequired === true) {
      const params = {
        signrequired: false
      }
      if (!toggleDisable.current) {
        toggleDisable.current = true

        dispatch(editNoticeType(item?.noticetypeid, params, (res) => {
          if (res) {
            const _upatedList = noticeTypeData?.map((innerItem) => {
              if (item?.noticetypeid === innerItem?.noticetypeid) {
                return { ...innerItem, signrequired: !innerItem?.signrequired }
              }
              return innerItem;
            })
            dispatch(editSignStatusReduxState(_upatedList))
            toggleDisable.current = false
          }
        }, (err) => {
          toggleDisable.current = false
          console.log(err);
        }))
      }
    } else {
      const params = {
        signrequired: true
      }
      if (!toggleDisable.current) {
        toggleDisable.current = true
        dispatch(editNoticeType(item?.noticetypeid, params, (res) => {
          if (res) {
            const _upatedList = noticeTypeData?.map((innerItem) => {
              if (item?.noticetypeid === innerItem?.noticetypeid) {
                return { ...innerItem, signrequired: !innerItem?.signrequired }
              }
              return innerItem;
            })
            dispatch(editSignStatusReduxState(_upatedList))
            toggleDisable.current = false
          }
        }, (err) => {
          toggleDisable.current = false
          console.log(err);
        }))
      }
    }

  };
  /**
   * Renders a clear search button component.
   * @returns None
   */
  const clearSearchButton = () => {
    smarttableref?.current?.querySelectorAll("button")[0].click();
  };

  /**
   * useEffect hook that updates the state of the edit button based on the value of the updateNotice variable.
   * If the updateNotice is an empty string, the edit button state is set to false.
   * @param {{string}} updateNotice - The update notice value.
   * @returns None
   */


  useEffect(() => {
    if (updateNotice === "") {
      setEditButtonstate(false);
    }
  }, [updateNotice]);


  /**
   * Loads more items when called. If already loading, it returns early.
   * Sets the loading state to true, then after a delay of 1000ms, sets the loading state to false
   * and increases the page size reference by 2.
   * @returns None
   */
  const loadMoreItems = () => {
    if (loading) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      pageSizeRef.current += 10;
    }, 1000);
  };

  /**
   * Debounces the handleTableScroll function to prevent excessive calls.
   * When the table container is scrolled, it checks if the scroll position is at the bottom
   * and if there are more items to load. If both conditions are met, it calls the loadMoreItems function.
   * @returns None
   */
  const handleTableScroll = debounce(() => {
    const tableContainer = tableContainerRef?.current;
    if (tableContainer) {
      const isAtBottom =
        tableContainer?.scrollTop + tableContainer?.clientHeight >=
        tableContainer?.scrollHeight;
      if (isAtBottom && noticeTypeData?.length > pageSizeRef?.current) {
        loadMoreItems();
      }
    }
  }, 200);

  /**
   * Adds an event listener to the table container element to handle scrolling.
   * The event listener is added when the component mounts and removed when the component unmounts.
   * @param {{function}} handleTableScroll - The function to handle the table scroll event.
   * @returns None
   */
  useEffect(() => {
    const tableContainer = tableContainerRef?.current;
    if (tableContainer) {
      tableContainer?.addEventListener("scroll", handleTableScroll);
    }
    return () => {
      if (tableContainer) {
        tableContainer?.removeEventListener("scroll", handleTableScroll);
      }
    };
  }, [handleTableScroll]);

  // const onTableFilterChange = (filterText) => {
  //   setSearchValue(filterText);
  // };
  const onTableFilterChange = (value) => {
    console.log('type added--', value)
    setSearchValue(value);

    console.log(noticeTypeData, 'noticeTypeData')
    // Filter the data based on the search value
    const filteredData = noticeTypeData?.filter(item =>
      item?.name?.toLowerCase().includes(value.toLowerCase()) ||
      item?.noofnotice?.toString().includes(value.toLowerCase())
    );
    console.log('filteredData', filteredData)
    // Update the state with the filtered data
    setSearchedData(filteredData);
  };
  const searchFilterClear = () => {
    smarttableref.current.querySelectorAll("button")[1].click();
  };

  /**
   * Renders a component that displays a list of notice types with various functionalities.
   * @param {{boolean}} showDeleteUserModal - Indicates whether the delete user modal should be shown.
   * @param {{function}} openDeleteUserModal - Function to open the delete user modal.
   * @param {{function}} closeDeleteUserModal - Function to close the delete user modal.
   * @param {{function}} onDeleteUser - Function to handle the deletion of a user.
   * @param {{function}} onProcced - Function to handle the proceed action.
   * @param {{Array}} columns - An array of columns to display in the table.
   * @param {{Array}} NoticeItem - An array of notice types to display.
   */
  return (

    <>
    <Helmet>
      <title>Notice Types | ScotRail Safety Notice Portal</title>
    </Helmet>
    <NoticeTypeComponent
      showDeleteUserModal={showDeleteUserModal}
      openDeleteUserModal={(e, item) => {
        openDeleteUserModal(e, item)
      }}
      closeDeleteUserModal={closeDeleteUserModal}
      onDeleteUser={() => onDeleteUser()}
      onProcced={onDeactivate}
      columns={columns}
      NoticeItem={noticeTypeData}
      clearSearchButton={clearSearchButton}
      showStatusModal={showStatusModal}
      noDataDesc={t(
        "YOUR_SEARCH_DID_NOT_MATCH_ANY_NOTICE_TYPE_PLEASE_TRY_SEARCHING_AGAIN"
      )}
      noDataTitle={t("NO_RESULT_FOUND")}
      noDataFound={t("NO_DATA_FOUND")}
      onCheckSign={(e, item) => onCheckSign(e, item)}
      onCheckAction={(e, item) => onCheckAction(e, item)}
      closeDeactiveModal={closeDeactivateModal}
      onUpdateNoticeType={(e, item) => onUpdateNoticeTypeFun(e, item)}
      placeHolderShimer={placeHolder}
      tableContainerRef={tableContainerRef}
      itemsPerPage={pageSizeRef.current}
      loading={loading}
      dimensions={dimensions}
      tableFilterHeight={tableFilterHeight}
      breadcrumbHeight={breadcrumbHeight}
      tabHeaderHeight={tabHeaderHeight}
      headerHeight={headerHeight}
      smarttableref={smarttableref}
      loaderHtml={loaderHtml}
      disableModelLoaderBotton={disableModelLoaderBotton}
      onTableFilterChange={onTableFilterChange}
      searchFilterClear={searchFilterClear}
      searchValue={searchValue}
      searchedData={searchedData}
    />
    </>
  );
};

export default NoticeType;
